import { snakeCase, startCase } from 'lodash';
import React, { FC } from 'react';
import styled from 'styled-components';
import { getValue } from 'components/organisms/tasks/criteria/single-select-base';
import { SelectFilterOperationType } from 'components/organisms/tasks/filters/select';
import { SingleSelectFieldFilter } from 'components/organisms/tasks/filters/single-select';
import { SingleUserFieldFilter } from 'components/organisms/tasks/filters/single-user';
import { TranslationKey, useTranslation } from 'hooks/use-translation';
import { byLabel } from 'utils/comparators/by-label';
import { removeTrailingDots } from './utils';

const Text = styled.span`
  max-width: inherit;
  text-wrap: wrap;
`;

const getFilterValues = (
  filter: SingleSelectFieldFilter | SingleUserFieldFilter,
  options,
): string[] => {
  const { type } = filter;

  return type === SelectFilterOperationType.Is ||
    type === SelectFilterOperationType.IsNot ||
    type === SelectFilterOperationType.IsAtLeast ||
    type === SelectFilterOperationType.IsAtMost ||
    type === SelectFilterOperationType.IsOneOf ||
    type === SelectFilterOperationType.IsNoneOf
    ? getValue(filter)
        .map((x) => options.find((u) => u?.value === x)!)
        .sort(byLabel)
        .map((x) => x?.label)
    : [];
};

export const SingleSelectBaseFilterToText: FC<{
  filter: SingleSelectFieldFilter | SingleUserFieldFilter;
  options;
}> = ({ filter, options }) => {
  const {
    field: { fieldLabel },
    type,
  } = filter;

  return (
    <Text>
      {startCase(fieldLabel)}{' '}
      {removeTrailingDots(
        useTranslation(
          `task_list.filters.${snakeCase(type)}` as TranslationKey,
        ),
      )}{' '}
      {getFilterValues(filter, options).join(', ')}
    </Text>
  );
};
